export default {
  saveToLocalStorage(key, item){
    localStorage.setItem(key, JSON.stringify(item));
  },
  getFromLocalStorage(key){
    return JSON.parse(localStorage.getItem(key))
  },
  removeFromLocalStorage(key){
    localStorage.removeItem(key)
  }
}